 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"COVID19Impact~DisciplineandAttendance~StudentPerformance~breakDownbyStudentGroup~schoolSpending~teac~0c607c61":"COVID19Impact~DisciplineandAttendance~StudentPerformance~breakDownbyStudentGroup~schoolSpending~teac~0c607c61","COVID19Impact~breakDownbyStudentGroup~schoolSpending~teacherWorkforce":"COVID19Impact~breakDownbyStudentGroup~schoolSpending~teacherWorkforce","COVID19Impact":"COVID19Impact","schoolSpending":"schoolSpending","teacherWorkforce":"teacherWorkforce","DisciplineandAttendance":"DisciplineandAttendance","StudentPerformance~breakDownbyStudentGroup~home~schoolDetail~searchResults~studentprogress":"StudentPerformance~breakDownbyStudentGroup~home~schoolDetail~searchResults~studentprogress","breakDownbyStudentGroup":"breakDownbyStudentGroup","StudentPerformance":"StudentPerformance","ECAcademicPerformance":"ECAcademicPerformance","Inspection Report~Inspections~Monitoring":"Inspection Report~Inspections~Monitoring","Inspection Report":"Inspection Report","Inspections~Monitoring":"Inspections~Monitoring","Inspections":"Inspections","Monitoring":"Monitoring","NotFound":"NotFound","compare~fav~schoolDetail~searchResults":"compare~fav~schoolDetail~searchResults","schoolDetail":"schoolDetail","schoolOverallPerformance~searchResults":"schoolOverallPerformance~searchResults","searchResults":"searchResults","home":"home","studentprogress":"studentprogress","academicPerformance":"academicPerformance","comingSoon":"comingSoon","compareSchools":"compareSchools","compare":"compare","fav":"fav","ecAbout":"ecAbout","masterLayout":"masterLayout","schoolAbout":"schoolAbout","schoolOverallPerformance":"schoolOverallPerformance"}[chunkId]||chunkId) + "." + {"COVID19Impact~DisciplineandAttendance~StudentPerformance~breakDownbyStudentGroup~schoolSpending~teac~0c607c61":"df7799c9","COVID19Impact~breakDownbyStudentGroup~schoolSpending~teacherWorkforce":"45301f49","COVID19Impact":"0c20f170","schoolSpending":"f1df9017","teacherWorkforce":"6d482dc6","DisciplineandAttendance":"306d8683","StudentPerformance~breakDownbyStudentGroup~home~schoolDetail~searchResults~studentprogress":"73f81716","breakDownbyStudentGroup":"28423b42","StudentPerformance":"4a225b99","ECAcademicPerformance":"74cc48b2","Inspection Report~Inspections~Monitoring":"e5840614","Inspection Report":"2644514d","Inspections~Monitoring":"d1e52545","Inspections":"f9d33d2c","Monitoring":"2e752810","NotFound":"f90e34b2","compare~fav~schoolDetail~searchResults":"d3037d87","schoolDetail":"f8209fee","schoolOverallPerformance~searchResults":"90d888ea","searchResults":"0e1fd131","home":"10ccd780","studentprogress":"3e86aaeb","academicPerformance":"757e3544","comingSoon":"9e6bb719","compareSchools":"a0b811b1","compare":"c2946baf","fav":"7138e12c","ecAbout":"52eb9573","masterLayout":"5a97c870","schoolAbout":"a9cd4626","schoolOverallPerformance":"5824215b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"COVID19Impact":1,"schoolSpending":1,"teacherWorkforce":1,"DisciplineandAttendance":1,"breakDownbyStudentGroup":1,"StudentPerformance":1,"ECAcademicPerformance":1,"Inspection Report":1,"Inspections":1,"Monitoring":1,"schoolDetail":1,"searchResults":1,"home":1,"studentprogress":1,"academicPerformance":1,"compareSchools":1,"compare":1,"fav":1,"ecAbout":1,"masterLayout":1,"schoolAbout":1,"schoolOverallPerformance":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"COVID19Impact~DisciplineandAttendance~StudentPerformance~breakDownbyStudentGroup~schoolSpending~teac~0c607c61":"COVID19Impact~DisciplineandAttendance~StudentPerformance~breakDownbyStudentGroup~schoolSpending~teac~0c607c61","COVID19Impact~breakDownbyStudentGroup~schoolSpending~teacherWorkforce":"COVID19Impact~breakDownbyStudentGroup~schoolSpending~teacherWorkforce","COVID19Impact":"COVID19Impact","schoolSpending":"schoolSpending","teacherWorkforce":"teacherWorkforce","DisciplineandAttendance":"DisciplineandAttendance","StudentPerformance~breakDownbyStudentGroup~home~schoolDetail~searchResults~studentprogress":"StudentPerformance~breakDownbyStudentGroup~home~schoolDetail~searchResults~studentprogress","breakDownbyStudentGroup":"breakDownbyStudentGroup","StudentPerformance":"StudentPerformance","ECAcademicPerformance":"ECAcademicPerformance","Inspection Report~Inspections~Monitoring":"Inspection Report~Inspections~Monitoring","Inspection Report":"Inspection Report","Inspections~Monitoring":"Inspections~Monitoring","Inspections":"Inspections","Monitoring":"Monitoring","NotFound":"NotFound","compare~fav~schoolDetail~searchResults":"compare~fav~schoolDetail~searchResults","schoolDetail":"schoolDetail","schoolOverallPerformance~searchResults":"schoolOverallPerformance~searchResults","searchResults":"searchResults","home":"home","studentprogress":"studentprogress","academicPerformance":"academicPerformance","comingSoon":"comingSoon","compareSchools":"compareSchools","compare":"compare","fav":"fav","ecAbout":"ecAbout","masterLayout":"masterLayout","schoolAbout":"schoolAbout","schoolOverallPerformance":"schoolOverallPerformance"}[chunkId]||chunkId) + "." + {"COVID19Impact~DisciplineandAttendance~StudentPerformance~breakDownbyStudentGroup~schoolSpending~teac~0c607c61":"31d6cfe0","COVID19Impact~breakDownbyStudentGroup~schoolSpending~teacherWorkforce":"31d6cfe0","COVID19Impact":"734a95b9","schoolSpending":"493010db","teacherWorkforce":"e53789a6","DisciplineandAttendance":"6c51a4fe","StudentPerformance~breakDownbyStudentGroup~home~schoolDetail~searchResults~studentprogress":"31d6cfe0","breakDownbyStudentGroup":"71b1426c","StudentPerformance":"aba6e240","ECAcademicPerformance":"dc23e887","Inspection Report~Inspections~Monitoring":"31d6cfe0","Inspection Report":"4db9323c","Inspections~Monitoring":"31d6cfe0","Inspections":"0b65f4e6","Monitoring":"b7f86424","NotFound":"31d6cfe0","compare~fav~schoolDetail~searchResults":"31d6cfe0","schoolDetail":"a899582b","schoolOverallPerformance~searchResults":"31d6cfe0","searchResults":"29e78e0d","home":"51fc9b14","studentprogress":"557545fb","academicPerformance":"7738b4ce","comingSoon":"31d6cfe0","compareSchools":"f3219cd4","compare":"694846cc","fav":"7f456f94","ecAbout":"c5cd05f3","masterLayout":"0215462a","schoolAbout":"61800e75","schoolOverallPerformance":"b2f8496a"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
